export const LOCALE_LANGUAGE_TAGS = {
  English: 'en',
  Ukrainian: 'uk',
};
